import { US_STATES } from '@belong/common';

const getSignDescriptionTemplate = (licenser) => {
  return `Belong is licensed by the ${licenser} and in every state where we operate, managing thousands of homes, just like\u00a0yours.`;
};

export const AGREEMENT_FLOW_STRINGS = {
  // 'UserPersonal.tips.title': 'Change of Address?',
  'UserPersonal.tips.description': [
    'We take the security of your personal information seriously. It stays between us; we’ll never give it\u00a0out.',
  ],
  personal_info: {
    title: 'You are a few steps away from joining\u00a0Belong.',
    subTitle:
      'Please confirm your personal\u00a0information so that we can generate tax\u00a0forms and send you documents in\u00a0the\u00a0future.',
    is_name_legal_question: "Is '{firstName} {lastName}' your legal name?",
    is_name_legal_yes: "Yes, that's correct.",
    is_name_legal_no: "No, it's different.",
    email: 'Email Address',
    phone: 'Phone Number',
    legal_first_name: 'Legal First Name',
    legal_middle_name: 'Legal Middle Name',
    legal_last_name: 'Legal Last Name',
    date_of_birth: 'Date Of Birth (MM/DD/YYYY)',
    current_address: 'Current Home Address',
    unit_number: 'Unit',
    same_mailing_address: 'THIS IS ALSO MY MAILING ADDRESS.',
    where_to_send_title: 'Where can we send you important\u00a0documents?',
    mailing_address: 'Mailing Address',
    next_button_text: 'Next',
  },

  //Plan page
  'Plan.tips.description': [
    'Great! Once we match you with your perfect Belong residents, we’ll deposit your rent on the first every\u00a0month,\u00a0guaranteed.',
  ],
  'plan.tips.guaranteed.title':
    "Great! Once we find someone to love your home, we'll deposit your rent on the 1st of each month, no matter\u00a0what.",
  'plan.tips.upfront.title':
    "Ok! The moment we find someone to love your home, we'll pay you the entire year's worth of income. In the meantime, if you currently have residents, we'll deduct 8% monthly from the time we start\u00a0managing.",
  'plan.tips.lets-discuss.title':
    "Ok! I'll reach out ASAP, or feel free to contact me\u00a0now.",
  'plan.title': 'Let’s get your home\u00a0loved.',
  'plan.title-plural': 'Let’s get your homes\u00a0loved.',
  'plan.which-plan.section-title':
    'When we find someone to love your home, how would you like to be\u00a0paid?',
  'plan.which-plan.section-subtitle':
    'You can always change this later, and again each time your home is\u00a0vacant.',
  'plan.which-plan.section-subtitle.plural':
    'You can always change this later, and again each time one of your homes become\u00a0vacant.',
  'plan.selector.guaranteed': 'Guaranteed Monthly',
  'plan.selector.guaranteed.subLabel':
    '{guaranteedManagementFee}% Management Fee',
  'plan.selector.upfront': 'Annual Upfront',
  'plan.selector.upfront.subLabel': '{upfrontManagementFee}% Management Fee',
  'plan.lets-discuss.label': "Not sure! Let's discuss it.",
  'plan.tax-deductible.text': 'Both Tax Deductible',
  'plan.tax-deductible.compare': 'Compare Plans',

  // Ownership page
  // 'Ownership.tips.title': 'Change of Address?',
  'Ownership.tips.description':
    'A growing form of identity theft involves impersonating a homeowner to collect rental income. To help combat this, later, we’ll verify the identity of each individual on title we’re working\u00a0with.',
  'ownership.title':
    'Of those who own the home, who will we primarily be working\u00a0with?',
  'ownership.title.plural':
    'Of those who own the homes, who will we primarily be working\u00a0with?',
  'ownership.subtitle':
    'Add a party on title who will be making decisions with Belong.',
  'ownership.another-individual.section-title': 'Let’s meet them!',
  'ownership.another-individual.section-subtitle':
    "We'll reach out to get some information and have them sign an\u00a0agreement.",
  'ownership.selector.me': 'Me',
  'ownership.selector.me.sublabel': '(As An Individual)',
  'ownership.selector.another-individual': 'Another Individual',
  'ownership.selector.entity': 'Entity Or Trust',
  'ownership.first-name': 'First Name',
  'ownership.last-name': 'Last Name',
  'ownership.email': 'Email',
  'ownership.phone': 'Phone',
  'ownership.entity.business-name': 'Business Name',
  'ownership.entity.self-managed': 'I manage this entity.',
  'ownership.entity.who-is.title': 'Who is?',
  'ownership.email.error': 'Cannot be same as your email',

  // Payment page
  // 'Payment.tips.title': 'Change of Address?',
  'Payment.tips.description':
    'Later, we’ll ask some additional information about this individual or entity to prepare tax forms come tax\u00a0season.',
  'payment.title':
    'One last thing... who should we make the checks out\u00a0to?',
  'payment.subtitle':
    'This will also be the primary point of contact when it comes to decision-making.',
  'payment.selector.me': 'Me',
  'payment.selector.me.sublabel': '(As An Individual)',
  'payment.selector.another-individual': 'Another Individual',

  //Sign step
  // 'Sign.tips.title': '',
  // TODO: Regions: Check it
  'Sign.tips.description': {
    [US_STATES.CA.code]: getSignDescriptionTemplate(
      'California Department of Real Estate (DRE License #02082345)',
    ),
    [US_STATES.TX.code]: getSignDescriptionTemplate(
      'Texas Department of Real Estate (DRE License\u00a0#9013886)',
    ),
    [US_STATES.UT.code]: getSignDescriptionTemplate(
      'Utah Department of Real Estate (DRE License\u00a0#13538686-CN00)',
    ),
    [US_STATES.WA.code]: getSignDescriptionTemplate(
      'Washington State Department of Licensing (License\u00a0#21028494)',
    ),
    'WA-notarize':
      'Leases longer than 12 months must be notarized in the state of Washington. We partner with Notarize to make this seamless. Every adult needs to sign in a timely manner to ensure you get the\u00a0home.',
    [US_STATES.FL.code]: getSignDescriptionTemplate(
      'Florida Department of Licensing (License\u00a0#CQ1065529)',
    ),
    [US_STATES.NC.code]: getSignDescriptionTemplate(
      'North Carolina Real Estate Commission (License\u00a0#C38631)',
    ),
    [US_STATES.GA.code]: getSignDescriptionTemplate(
      'Georgia Real Estate Commission (License\u00a0#81255)',
    ),
    [US_STATES.SC.code]: getSignDescriptionTemplate(
      'South Carolina Real Estate Commission (License\u00a0#27097)',
    ),
    [US_STATES.CO.code]: getSignDescriptionTemplate(
      'Colorado Department of Regulatory Agencies, Division of Real Estate (IC.\u00a0100107131)',
    ),
    [US_STATES.IL.code]: getSignDescriptionTemplate(
      'Illinois Division of Real Estate (License\u00a0#478.027701)',
    ),
    [US_STATES.TN.code]: getSignDescriptionTemplate(
      'Tennessee Real Estate Commission (License\u00a0#3002945415)',
    ),
    [US_STATES.NV.code]: getSignDescriptionTemplate(
      'Department of Business and Industry Nevada Real Estate Division (License\u00a0PM.0168524.BKR)',
    ),
    [US_STATES.PA.code]: getSignDescriptionTemplate(
      'Pennsylvania Real Estate Commission (License\u00a0RB070118)',
    ),
    [US_STATES.NY.code]: getSignDescriptionTemplate(
      'New York State Department of State (License\u00a010991241125)',
    ),
    [US_STATES.AZ.code]: getSignDescriptionTemplate(
      'Arizona Department of Real Estate (License\u00a0CO717003000)',
    ),
    [US_STATES.MD.code]: getSignDescriptionTemplate(
      'Maryland Department of Labor, Real Estate Comission (License\u00a0#6477)',
    ),
    [US_STATES.OH.code]: getSignDescriptionTemplate(
      'Ohio Department of Commerce (License\u00a0REC.2025001780)',
    ),
    [US_STATES.MA.code]: getSignDescriptionTemplate(
      'Massachusetts Board of Registration of Real Estate Brokers and Salespersons (License\u00a0#424749)',
    ),
    [US_STATES.VA.code]: getSignDescriptionTemplate(
      'Virginia Real Estate Commission (License\u00a0#226038733)',
    ),
    [US_STATES.DC.code]: getSignDescriptionTemplate(
      'DC Department of Licensing and Consumer Protection, Real Estate Commission (License\u00a0REO40000454)',
    ),
    [US_STATES.MI.code]: getSignDescriptionTemplate(
      'Michigan Department of Licensing and Regulatory Affairs (License\u00a0#6505433907)',
    ),
    [US_STATES.NH.code]: getSignDescriptionTemplate(
      'New Hampshire Office of Professional Licensure and Certification, Real Estate Commission (License\u00a0OP-0077860-RECOM)',
    ),
    [US_STATES.RI.code]: getSignDescriptionTemplate(
      'Rhode Island Real Estate Commission (License\u00a0REC.0208155)',
    ),
  },
  'sign.title': `Here's everything you need to know about joining\u00a0Belong.`,
  'sign.title.updated': `As discussed, we've updated your Belong\u00a0Plan.`,
  'sign.subtitle': `We just need to get some legal stuff out of the way\u00a0first...`,
  'sign.summary.first':
    'You may cancel anytime, free of charge, until we agree on and perform repairs or manage residents in your\u00a0home.',
  'sign.summary.second':
    'Once we place residents in your home, you get paid on the first of each month,\u00a0guaranteed.',
  'sign.summary.third':
    'You are covered up to 3 months of rent for eviction\u00a0protection.',
  'sign.summary.fourth':
    'You approve home maintenance requests by residents up\u00a0to\u00a0${threshold}.',
  'sign.continueReading': 'Continue Reading',
  'sign.download': 'Download PDF',
  'sign.download.addendums': 'Download All',
  'sign.download.fullDocument': 'VIEW FULL DOCUMENT',
  'sign.checkbox': 'I AGREE TO SIGN THESE TERMS AND\u00a0CONDITIONS',
  'sign.CTA': 'Continue Onboarding',
  'sign.checkbox.addendums':
    'I agree to electronically sign this agreement and its\u00a0addendums.',
  'sign.cancelAnytime': 'Cancel Anytime',
  'sign.cancelAnytime.description':
    'We stand by our service. Joining is free, and you can cancel anytime pre-lease without\u00a0fees.',
  'sign.guaranteedRent': 'Guaranteed Rent',
  'sign.guaranteedRent.description':
    'Complete peace of mind. Once we place residents, you get paid on the first, no matter\u00a0what.',
  'sign.evictionProtection': 'Eviction Protection',
  'sign.evictionProtection.description':
    'We offer coverage of up to 3 months of rent against legal fees in the event of an\u00a0eviction.',
  'sign.personalConcierge': 'Personal Concierge',
  'sign.personalConcierge.description':
    'Enjoy a dedicated professional who cares about you, your home, and your\u00a0residents.',
  'sign.trustedVendors': 'Trusted Pros',
  'sign.trustedVendors.description':
    'We ensure top-notch maintenance quality to maximize the long-term value of your\u00a0home.',
  'sign.allDaySupport': '24/7 Support',
  'sign.allDaySupport.description':
    'Our service never sleeps. In the event of an emergency, our team is there to handle any\u00a0situation.',
  'sign.error':
    "Oh, no! Something has failed on our end. Please contact {email} - {phoneNumber} and we'll help\u00a0immediately.",

  // Success Page
  'success.home.string': 'home',
  'success.default': `Congrats on joining Belong's network! Let's start by onboarding your\u00a0home.`,
  'success.co-signer.signatures-left':
    "You're all Set! We'll send an invite to {primaryHOName} to complete the onboarding\u00a0process.",
  'success.co-signer.all-signed':
    'We look forward to giving your {homeString} a whole lot of\u00a0love.',
  'success.primary.far-off.occupied':
    'Alright, you’re a Belong Homeowner! As we get closer to your move out, we’ll reach out to get you set up. In the meantime, please let us know if anything changes on your\u00a0end.',
  'success.primary.far-off.vacant':
    'Alright, you’re a Belong Homeowner! As we get closer to your {homeOrHomes} becoming available, we’ll reach out to get you set up. In the meantime, please let us know if anything changes on your\u00a0end.',
  'success.primary.far-off.mixed':
    'Alright, you’re a Belong Homeowner! As we get closer to your homes becoming available, we’ll reach out to get you set up. In the meantime, please let us know if anything changes on your\u00a0end.',
  'success.primary.signatures-left.one':
    "We'll send an invite to {nameYetToSign} to complete the onboarding\u00a0process.",
  'success.primary.signatures-left.multiple':
    "We'll send invites to {namesYetToSign} to complete the onboarding\u00a0process.",
  'success.non-signer.info-title': 'Note',
  'success.non-signer.info':
    "As you are not on title, you will no longer see this home in your account. But that doesn't mean we don't look forward to working with\u00a0you!",
  'success.cta': 'Go To Main Page',
  shareableInfo: {
    bannerTitle: 'Love working with Belong so\u00a0far?',
    bannerMessage: 'Refer your favorite homeowner. Earn\u00a0$1,000.',
    shareableMessage:
      'I just started working with Belong, and am loving my experience. Belong takes care of everything, from guaranteeing my rent to providing 24/7 support to me and my resident. If you own a rental home, check them\u00a0out!',
  },
  belongStandards:
    'Belong’s Open Standards govern how we take care of your\u00a0home.',
  belongStandardsPostInspection:
    'Belong’s Open Standards govern how\u00a0we\u00a0operate.',
  learnMore: 'Learn More',
};
